module.exports = __webpack_public_path__ + "static/media/etiketoinnista-laatikkoon.4f666cdd.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/etiketoinnista-laatikkoon.mp4
 ** module id = 447
 ** module chunks = 0
 **/